module.exports = __webpack_public_path__ + "static/travel-ea163b1b4f2ace61dcabc02378ac7e0a.svg";